<template>
    <b-tab title="ข้อมูลรถ">
        <b-row>
            <b-col lg="12" class="my-2">
                <h4 class="text-muted">ข้อมูลรถ</h4>
            </b-col>
            <b-col lg="12" class="my-2">
                <label>สถานะรถ</label>
                <div>
                    <b-badge :variant="getStatusCarBadgeVariant(carDetails.status).color">
                        {{getStatusCarBadgeVariant(carDetails.status).title}}
                    </b-badge>
                </div>
            </b-col>
            <b-col cols="6">
                <b-form-group label="ประเภทรถ">
                    <multiselect
                        v-model="carDetails.vehicleCategory"
                        deselect-label="Can't remove this value"
                        track-by="id"
                        label="name"
                        placeholder="ค้นหาประเภทรถ"
                        :options="LIST_TYPE_CAR"
                        :allow-empty="false"
                    ></multiselect>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="ทะเบียนรถ">
                    <b-form-input
                        placeholder="ระบุทะเบียนรถ"
                        v-model="carDetails.vehiclePlate"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="จังหวัด">
                    <b-form-input
                        placeholder="ระบุจังหวัด"
                        v-model="carDetails.province"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="ยี่ห้อ">
                    <b-form-input
                        placeholder="ระบุยี่ห้อ"
                        v-model="carDetails.brand"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="ปีที่ผลิต">
                    <b-form-input
                        placeholder="ระบุปีที่ผลิต"
                        v-model="carDetails.yearCreate"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="ชนิดเครื่องยนตร์">
                    <b-form-input
                        placeholder="ระบุชนิดเครื่องยนตร์"
                        v-model="carDetails.engineType"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="ขนาดเครื่องยนตร์">
                    <b-form-input
                        placeholder="ระบุขนาดเครื่องยนตร์"
                        v-model="carDetails.engineSize"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="ระบบขับเคลื่อน">
                    <b-form-input
                        placeholder="ระบุระบบขับเคลื่อน"
                        v-model="carDetails.driveSystem"
                    />
                </b-form-group>
            </b-col>
        </b-row>
    </b-tab>
</template>

<script>
import { getStatusCarBadgeVariant } from "@/util/constants.js"
import vehicleTypeService from "@/api/vehicle-type.service.js"

export default {
    data(){
        return {
            LIST_TYPE_CAR: [],
            getStatusCarBadgeVariant,
            isLoadPage: false
        }
    },
    props:{
        carDetails: {
            type: Object
        }
    },
    async mounted(){
        await this.getCategory();
    },
    methods: {
        async getCategory (){
            const { data } = await vehicleTypeService.getVehicleCategory()
            this.LIST_TYPE_CAR = data.data
        },
    }
}
</script>
